import { render, staticRenderFns } from "./CertificadoSideBar.vue?vue&type=template&id=3ec6393c&scoped=true"
import script from "./CertificadoSideBar.vue?vue&type=script&lang=js"
export * from "./CertificadoSideBar.vue?vue&type=script&lang=js"
import style0 from "./CertificadoSideBar.vue?vue&type=style&index=0&id=3ec6393c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec6393c",
  null
  
)

export default component.exports